module.exports = __webpack_public_path__ + "img/video-verification-illustration.ab632295.png";